import { Agent } from '@typings/dify'
import dayjs from 'dayjs'

export const getChartData = (agents: Agent[], timeRange: '3m' | '6m' | '1y') => {
  const messageCounts: Record<string, number> = {}
  const likeCounts: Record<string, number> = {}

  // Calculate the start date based on the time range
  const now = dayjs()
  const startDate =
    timeRange === '3m'
      ? now.subtract(3, 'month')
      : timeRange === '6m'
        ? now.subtract(6, 'month')
        : now.subtract(1, 'year')

  agents
    .flatMap((agent) => agent.conversations)
    .flatMap((conversation) => conversation.messages)
    .forEach((message) => {
      const timestamp = parseInt(message.timestamp) * 1000
      const dateObj = dayjs(timestamp)

      // Skip invalid or out-of-range messages
      if (!dateObj.isValid() || !dateObj.isAfter(startDate)) return

      // Format the date as "MMM YYYY"
      const date = dateObj.format('MMM YYYY')

      // Increment message count for user messages
      if (message.role === 'user') {
        console.log(message.content)
        messageCounts[date] = (messageCounts[date] || 0) + 1
      }

      // Increment like count for liked messages
      if (message.liked) {
        likeCounts[date] = (likeCounts[date] || 0) + 1
      }
    })

  // Format and sort the data for charts
  const formattedMessageData = Object.entries(messageCounts)
    .map(([date, count]) => ({ date, value: count }))
    .sort((a, b) => dayjs(a.date, 'MMM YYYY').diff(dayjs(b.date, 'MMM YYYY')))

  const formattedLikeData = Object.entries(likeCounts)
    .map(([date, count]) => ({ date, value: count }))
    .sort((a, b) => dayjs(a.date, 'MMM YYYY').diff(dayjs(b.date, 'MMM YYYY')))

  return { messages: formattedMessageData, likes: formattedLikeData }
}
